module.exports = __webpack_public_path__ + "img/Virtual_Avatars_and_Story.6f6c9b61.jpg";